import { makeStyles, createStyles } from '@material-ui/core'

export const useAccountStyles = makeStyles((theme) =>
  createStyles({
    accountContainer: {
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(8),
      },
    },
    sticky: {
      [theme.breakpoints.up('md')]: {
        position: 'sticky',
        top: theme.sizes.headerHeight + theme.spacing(2),
      },
    },
    background: {
      background: theme.extraColors.greyLight,
    },
    text: {
      marginBottom: theme.spacing(2),
    },
    desc: {
      maxWidth: 300,
    },
    accountHeader: {
      width: '100%',
    },
    main: {
      textAlign: 'center',
      margin: theme.spacing(8, 0),
    },
    infosLink: {
      display: 'inline-flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      color: theme.extraColors.greyText,
    },
    infosLinkContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(2),
      },
    },
    questionContainer: {
      background: theme.palette.common.white,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(3),
    },
    smallMarginBottom: {
      marginBottom: theme.spacing(2),
    },
    stepLabel: {
      color: theme.palette.secondary.main,
    },
    loaderSection: {
      height: '70vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    loaderSectionFull: {
      height: '100vh',
    },
    link: {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    loaderContainer: {
      height: 300,
      width: '100%',
      alignContent: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    warning: {
      margin: theme.spacing(6, 0, 0),
      padding: theme.spacing(2, 3),
      borderRadius: theme.shape.borderRadius,
      background: theme.palette.warning.light,
      color: theme.palette.warning.contrastText,
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    warningContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      [theme.breakpoints.up('lg')]: {
        flexDirection: 'row',
        alignItems: 'center',
        '&>.MuiTypography-root': {},
        '&>div': {
          whiteSpace: 'nowrap',
        },
      },
    },
    warningContainerAlt: {
      [theme.breakpoints.up('lg')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    warningBtn: {
      color: theme.palette.warning.light,
      background: theme.palette.warning.contrastText,
    },
    center: {
      textAlign: 'center',
    },
  })
)
